<div class="container p-5">

  <div class="w-100 d-flex flex-column justify-content-center align-items-center height-80">
    <i class="fa fa-check-circle text-primary" style="font-size:100px"></i> <p class="fs-1">Úspěšně rezervováno</p>
    <p >Potvrzení bylo zasláno na Váš email a formou SMS na telefonní číslo uvedené ve Vašem profilu</p>
    <button routerLink="/user/reservations" class="btn btn-primary text-white mt-5"><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Moje rezervace</button>
  </div>

</div>
